import { Button } from 'src/components/Button';
import styled from 'styled-components';
import waterMarkBackgroundUrlDark from '../../../assets/images/watermark-dark-background.svg';
import waterMarkBackgroudnUrlLight from '../../../assets/images/watermark-light-background.svg';
import light from '../../../assets/style/themes/light';

export const Container = styled.div`
  width: 100%;
  overflow: hidden;
  height: 260px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${(props) => (props.theme === light ? waterMarkBackgroudnUrlLight : waterMarkBackgroundUrlDark)});
`;

export const Space = styled.div`
  width: 100%;
  align-items: center;
  display: inline-flex;
  flex-direction: row;
  height: 100%;

  justify-content: center;

  @media (max-width: 1024px) {
    flex-direction: column;
  };
`;

export const WaterMark = styled.img`
  max-width: 70%;
  max-height: 65%;
  margin-left: 40px;
  opacity: ${(props) => (props.theme.title === 'dark' ? 0.7 : 0.3)};
  @media (max-width: 1024px) {
    margin: auto;

    max-width: 50%;
    max-height: 65%;
  };
`;

export const TextWrapper = styled.div`
  max-width: 80%;
  margin-left: 37.9px;
  margin-right: 20px;

  @media (max-width: 1024px) {
    margin: auto;
    margin-top: 0;
  };
`;

export const TextRow = styled.div`
  width: 83.53px;
  height: 1px;
  border-top: 1px solid ${(props) => props.theme.colors.chartEmptyTextRowColor};
`;

export const InfoText = styled.h1`
  font-size: 24px;
  line-height: 28px;
  color: ${(props) => props.theme.colors.chartEmptyHeaderTextColor};
  width: 100%;
  font-size: 2.0rem;
  font-weight: 700;
  margin-bottom: 6px;

  @media (max-width: 586px) {
    max-width: 100%;
    border-radius: 0;
    font-size: 1.7rem;
  }

`;

export const HelperText = styled.p`
  color: ${(props) => props.theme.colors.chartEmptyHelperTextColor};
  font-weight: 400;
  font-size: 14px;
  margin-top: 6px;

  max-width: 256px;
`;

/** Evolutivo de cruzamentos - temporário, será substituido por um componente geral */
export const CallToActionButton = styled(Button)`
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.EvolutivevOkButtonColor};

  &:hover {
    background-color: ${({ theme }) => theme.colors.EvolutivevOkButtonColor};
    opacity: 0.8;
  }
`;
